import type {
  CreateBrandReply,
  CreateBrandRequest,
  ListBrandsReply,
  ListBrandsRequest,
} from '@/types';
import api from './api';

export const brandApi = {
  createBrand: async (data: CreateBrandRequest): Promise<CreateBrandReply> => {
    return api.post('/api/v1/brands/create', data);
  },

  listBrands: async (data: ListBrandsRequest): Promise<ListBrandsReply> => {
    return api.post('/api/v1/brands/list', data);
  },
};
